export default class BannerZoneModel {
    zoneId: number;
    position: number;
    banner: {
        id: number;

        clickUrl: string;
        iframeUrl: string;
        trackerUrl: string;
        height: number;
        width: number;
        raw: string;
        contentType: string;
        html: string;
        keywords: string;
        vastUrl: string;
        iframeAppendUrl: string;
        isVpaid: boolean;
        posterUrl: string;
    };

    selector: string;
    adsManager: any;
    adDisplayContainer: any;
    adsLoader: any;

    constructor(data: any) {
        this.zoneId = data['zoneId'] || 0;
        this.position = data['position'] || 0;
        this.banner = {
            id: data['banner']['id'] || 0,
            clickUrl: data['banner']['clickUrl'] || '',
            iframeUrl: data['banner']['iframeUrl'] || '',
            trackerUrl: data['banner']['trackerUrl'] || '',
            height: data['banner']['height'] || 0,
            width: data['banner']['width'] || 0,
            raw: data['banner']['raw'] || '',
            contentType: data['banner']['contentType'] || '',
            html: data['banner']['html'] || '',
            keywords: data['banner']['keywords'] || '',
            vastUrl: data['banner']['vastUrl'] || '',
            iframeAppendUrl: data['banner']['iframeAppendUrl'] || '',
            isVpaid: data['banner']['isVpaid'] || '',
            posterUrl: data['banner']['isVposterUrlpaid'] || '',
        }
    }
}
